import { useMainContext } from '@contexts/Contexts';
import { Toggle } from './Toggle';
import { getAvailableTerms } from '@utils/TalksUtils';
import classNames from 'classnames';

export const TermFilter = ({ terms, allowed, selected, onClick, taxonomy }) => {
	const list = [];

	const { state } = useMainContext();
	const { filteredTalks = [] } = state;

	const termsAvailable = getAvailableTerms(filteredTalks, taxonomy);

	if (allowed.length > 0 && termsAvailable.length > 0) {
		// If allowed in the filter is not in the available terms then remove it from the allowed array

		allowed.forEach((id, index) => {
			const current = terms.filter((obj) => {
				return obj.term_id === id;
			});

			const { name } = current[0] ? current[0] : { name: '' };

			const isDisabled = !termsAvailable.includes(id);

			// Disable the filter because it is not in the available terms
			const classes = classNames(
				'category-filter-item',
				isDisabled ? 'disabled' : '',
			);

			list.push(
				<div
					className={classes}
					key={index}
					onClick={() => {
						onClick(id, isDisabled);
					}}
				>
					<Toggle
						className="category-filter-item-toggle"
						toggled={selected.includes(id)}
					/>
					<div className="category-filter-item-name">{name}</div>
				</div>,
			);
		});
	}

	return list;
};
